const socialPlatformDetails = {
  instagram: { name: "Instagram", subtitle: "Business account", icon: "ti-brand-instagram", tone: "instagram" },
  facebook: { name: "Facebook", accountName: "Facebook Pages", subtitle: "Business page", icon: "ti-brand-facebook", tone: "facebook" },
  linkedin: { name: "LinkedIn", subtitle: "Professional profile", icon: "ti-brand-linkedin", tone: "linkedin" },
  x: { name: "X", accountName: "X", subtitle: "Twitter account", icon: "ti-brand-x", tone: "x" },
  youtube: { name: "YouTube", subtitle: "Channel", icon: "ti-brand-youtube", tone: "youtube" },
  tiktok: { name: "TikTok", subtitle: "Creator account", icon: "ti-brand-tiktok", tone: "tiktok" },
  pinterest: { name: "Pinterest", subtitle: "Business account", icon: "ti-brand-pinterest", tone: "pinterest" },
  threads: { name: "Threads", subtitle: "Threads profile", icon: "ti-at", tone: "threads" },
  google_business: { name: "Google Business Profile", subtitle: "Business listing", icon: "ti-brand-google-maps", tone: "google" }
};

export default socialPlatformDetails;
